<header>
    <div class="container">
        <div class="header-row">
            <a href="https://vicimus.com" id="logo" title="Vicimmus">
                <img src="https://vicimus.com/wp-content/uploads/2023/08/logo.svg" width="311" height="42" alt="Vicimmus">
            </a>

            <div class="link-group">
                <a href="mailto:support@vicimus.com">
                    <i class="fa-solid fa-envelope"></i> support&#64;vicimus.com
                </a>
                <a mat-button mat-flat-button color="primary"
                   [routerLink]="user?.store?.id ? '/admin/' + user.store.id + '/dashboard' : '/admin'"
                >
                    Dashboard
                </a>
            </div>
        </div>
    </div>
</header>

<main>
    <div class="hero-block">
        <div class="container">
            <div class="row">
                <div class="col">
                    <div class="content-block">
                        <span class="logo-stuff"><img src="https://vicimus.com/wp-content/uploads/2023/08/bumper-finance-white-1.svg" width="94" height="44" alt="Flame"> BUMPER FINANCE </span>

                        <h1>
                            Have a sales code? Continue your sale by clicking below
                        </h1>

                        <div class="button-area">
                            <button mat-button mat-flat-button color="primary" (click)="onSaleEntry()">
                                Enter Sales Code
                            </button>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="img-block">
                        <figure><img src="https://vicimus.com/wp-content/uploads/2023/08/accessories_accelerator-2.png" alt="Dashboard Screen" width="920" height="628"></figure>
                    </div>
                </div>
            </div>
        </div>
    </div>
</main>

<footer>
    <div class="container">
        <div class="footer-content">
            <span>© Vicimus {{year}}, All Rights Reserved</span>
            <ul class="dots-listing">
                <li>
                    <a href="https://vicimus.com/privacy-policy.html">Privacy Policy</a>
                </li>
                <li>
                    <a href="https://vicimus.com/terms-conditions.html">Terms of Service</a>
                </li>
            </ul>
        </div>
    </div>
</footer>
